import React from "react";
import clsx from "clsx";
import "./chat-box-view.styles.scss";

import zCBLAnimationModule from "../../core/engines";
import { ChatBoxViewHeader } from "../ChatBoxViewHeader";
import { ChatBoxListView } from "../ChatBoxListView";
import { ChatBoxBar } from "../ChatBoxBar";
import { ChatBoxInput } from "../ChatBoxInput";

export interface ChatBoxViewProps {
	className?: string;
	scrollerElementId: string;
}

const BlockName = "chat-box-view";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		Header: `${BlockName}__header`,
		Body: `${BlockName}__body`,
		Footer: `${BlockName}__footer`,
	},
} as const;

export type ChatBoxViewComponent = React.FC<ChatBoxViewProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxView = ((props: ChatBoxViewProps) => {
	return (
		<div className={clsx(ChatBoxView.ClassNames.Block, props.className)}>
			<ChatBoxViewHeader className={ChatBoxView.ClassNames.Elements.Header} />
			<div className={ChatBoxView.ClassNames.Elements.Body}>
				<zCBLAnimationModule.Component.CBLAnimationNGProvider>
					<ChatBoxListView scrollerElementId={props.scrollerElementId} />
				</zCBLAnimationModule.Component.CBLAnimationNGProvider>
			</div>
			<div className={ChatBoxView.ClassNames.Elements.Footer}>
				<ChatBoxBar />
				<ChatBoxInput />
			</div>
		</div>
	);
}) as ChatBoxViewComponent;
ChatBoxView.ClassNames = ClassNames;
